import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsMaintenanceJob, PmsMaintenanceJob } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsMaintenanceJob>
    useData={usePmsMaintenanceJob}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
